import { render, staticRenderFns } from "./ForumGroupSettings.vue?vue&type=template&id=866c8730&scoped=true&"
import script from "./ForumGroupSettings.vue?vue&type=script&lang=js&"
export * from "./ForumGroupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c8730",
  null
  
)

export default component.exports